<template>
  <section id="MultipleChoiceQuiz">
    <transition
      name="fade"
      mode="out-in"
    >
      <div v-if="step === 1 || step === 2">
        <h5>Question 1/3</h5>
        <h3>Which country do you think made the most calls per user?</h3>
        <button
          v-for="country in q1Countries"
          @click="answers[0] = country"
          class="button button--selectable"
          :class="{
            'selected': answers[0] === country,
            'correct': country === 'Pakistan' && step === 2,
            'wrong': answers[0] === country && answers[0] !== 'Pakistan' && step === 2
          }"
          :key="country"
        >{{ country }}</button>
        <button
          class="button button--white c-blue"
          :disabled="!answers[0]"
          @click="answerQ1"
        >Continue</button>
        <button
          class="button button--plain"
          @click="revealAnswer"
        >No thanks, just show me the answers</button>
      </div>
      <div v-else-if="step === 3 || step === 4">
        <h5>Question 2/3</h5>
        <h3>Which country do you think sent the most messages per user?</h3>
        <button
          v-for="country in q2Countries"
          @click="answers[1] = country"
          class="button button--selectable"
          :class="{
            'selected': answers[1] === country,
            'correct': country === 'Tanzania' && step === 4,
            'wrong': answers[1] === country && answers[1] !== 'Tanzania' && step === 4
          }"
          :key="country"
        >{{ country }}</button>
        <button
          class="button button--white c-blue"
          :disabled="!answers[1]"
          @click="answerQ2"
        >Continue</button>
      </div>
      <div v-else-if="step === 5 || step === 6">
        <h5>Question 3/3</h5>
        <h3>Which country made the least amount of calls per user?</h3>
        <button
          v-for="country in q3Countries"
          @click="answers[2] = country"
          class="button button--selectable"
          :class="{
            'selected': answers[2] === country,
            'correct': country === 'Taiwan' && step === 6,
            'wrong': answers[2] === country && answers[2] !== 'Taiwan' && step === 6
          }"
          :key="country"
        >{{ country }}</button>
        <button
          class="button button--white c-blue"
          :disabled="!answers[2]"
          @click="answerQ3"
        >Continue</button>
      </div>
      <div v-else>
        <ul class="stats">
          <li class="stat">
            <!--
            <img
              v-if="answers.length && answers[0] !== 'Pakistan'"
              class="stat__icon"
              src="@/assets/icons/cross-border-icon.svg"
            >
            <img
              v-else
              class="stat__icon"
              src="@/assets/icons/tick-border-icon.svg"
            >
            -->
            <div class="stat__text">Pakistan made the most calls per user</div>
          </li>
          <li class="stat">
            <!--
            <img
              v-if="answers.length && answers[1] !== 'Tanzania'"
              class="stat__icon"
              src="@/assets/icons/cross-border-icon.svg"
            >
            <img
              v-else
              class="stat__icon"
              src="@/assets/icons/tick-border-icon.svg"
            >
            -->
            <div class="stat__text">Tanzania sent the most amount of messages per user</div>
          </li>
          <li class="stat">
            <!--
            <img
              v-if="answers.length && answers[2] !== 'Taiwan'"
              class="stat__icon"
              src="@/assets/icons/cross-border-icon.svg"
            >
            <img
              v-else
              class="stat__icon"
              src="@/assets/icons/tick-border-icon.svg"
            >
            -->
            <div class="stat__text">Taiwan made the least amount of calls per user</div>
          </li>
        </ul>
      </div>
    </transition>
    <QuizModal
      :title="quizModalTitle"
      :show="showQuizModal"
      :fb="fb"
      :tw="tw"
      :wa="wa"
      @close="showQuizModal = false"
    />
  </section>
</template>

<script>
import { ref } from "vue";
import QuizModal from "@/components/QuizModal";
import { useGtag } from "vue-gtag-next";
import sharing from "@/share";

export default {
  components: {
    QuizModal,
  },
  setup() {
    const { event } = useGtag();
    const step = ref(1);
    const answers = ref([]);
    const q1Countries = ref(["France", "Pakistan", "Argentina"]);
    const q2Countries = ref(["Finland", "Canada", "Tanzania"]);
    const q3Countries = ref(["Australia", "Egypt", "Taiwan"]);
    const showQuizModal = ref(false);
    const quizModalTitle = ref(null);

    const fb = ref(
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        sharing.multipleChoiceQuiz.url
      )}`
    );
    const tw = ref(
      `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        sharing.multipleChoiceQuiz.tw + " " + sharing.multipleChoiceQuiz.url
      )}`
    );
    const wa = ref(
      `whatsapp://send?text=${encodeURIComponent(
        sharing.multipleChoiceQuiz.wa + " " + sharing.multipleChoiceQuiz.url
      )}`
    );

    function answerQ1() {
      step.value++;
    }
    function answerQ2() {
      step.value++;
    }
    function answerQ3() {
      step.value++;
      let numberOfCorrectAnswers = 0;
      if (answers.value[0] === "Pakistan") numberOfCorrectAnswers++;
      if (answers.value[1] === "Tanzania") numberOfCorrectAnswers++;
      if (answers.value[2] === "Taiwan") numberOfCorrectAnswers++;
      quizModalTitle.value = `${numberOfCorrectAnswers} out of 3!`;
      showQuizModal.value = true;
      event("completed_multiple_choice_quiz", {
        event_category: "quiz",
        event_label: "multiple_choice_quiz",
      });
    }
    function revealAnswer() {
      step.value = 7;
      event("skipped_multiple_choice_quiz", {
        event_category: "quiz",
        event_label: "multiple_choice_quiz",
      });
    }
    return {
      step,
      answers,
      q1Countries,
      q2Countries,
      q3Countries,
      answerQ1,
      answerQ2,
      answerQ3,
      revealAnswer,
      showQuizModal,
      quizModalTitle,
      fb,
      tw,
      wa,
    };
  },
};
</script>

<style>
#MultipleChoiceQuiz {
  background-color: var(--blue);
  background-image: url("../assets/images/world.svg"),
    url("../assets/images/bg-pattern.png");
  background-position: center center, center center;
  background-size: contain, cover;
  background-repeat: no-repeat;
  padding: 48px 20px;
  position: relative;
}
#MultipleChoiceQuiz > div {
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
}
#MultipleChoiceQuiz h5 {
  font-size: 20px;
  line-height: 24px;
  opacity: 0.6;
  margin-bottom: 32px;
}
#MultipleChoiceQuiz h3 {
  font-size: 24px;
  line-height: 29px;
  margin-bottom: 24px;
}

#MultipleChoiceQuiz > div {
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: center;
  transition: all 0.5s ease;
}
@media screen and (min-width: 720px) {
  #MultipleChoiceQuiz h3 {
    font-size: 56px;
    line-height: 68px;
    margin-bottom: 48px;
  }
}
</style>